import http from "./http"
import { getToken } from './auth'

const base = 'jobs'

// Job documentation notes — a note and/or photos attached to a job by whoever
// was on site (e.g. a carpet that arrived damaged). Append-only on the API:
// create + read only, nothing is ever edited or removed.
export async function getJobNotes(jobId) {
    const { data } = await http.get(`${base}/${jobId}/notes`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

// `photos` are the bucket paths returned by uploadJobNotePhoto (legacy public
// URLs still accepted). `visibleToCustomer` shares the note and all its
// photos on the customer's tracking page.
export async function createJobNote(jobId, { note, photos, visibleToCustomer = false }) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken(),
        }
    }

    const { data } = await http.post(`${base}/${jobId}/notes`, { note, photos, visibleToCustomer }, config)
    return data
}

// Photo upload — sends the raw image file, same as the client avatar upload;
// the API stores it under this job's folder in the PRIVATE photos bucket and
// returns { url, path } (url = short-lived signed preview, path = the stored
// reference). It creates no note by itself: the returned paths are submitted
// with createJobNote, and the API only accepts paths it issued for that job.
export async function uploadJobNotePhoto(jobId, file) {
    const { data } = await http.post(`${base}/${jobId}/notes/photo`, file, {
        headers: {
            'Content-Type': file.type,
            'Authorization': 'Bearer ' + getToken(),
        }
    })
    return data
}
